import React, { useEffect } from 'react';

import { nfcScan } from '../../utils/nfc-scan';

interface NFCScanProps {
    onScan: (result: React.SetStateAction<string | null>) => void;
    onError: (err: string) => void;
}

export const NFCScan: React.FC<NFCScanProps> = ({ onScan, onError }) => {
    useEffect(() => {
        const scanPromise = nfcScan({
            onDetect: onScan,
            onError,
        });

        return () => {
            if (scanPromise) {
                scanPromise.then((cleanup) => cleanup && cleanup());
            }
        };
    }, [onError, onScan]);

    return null;
};
